// Active visitor tracking removed.
export const useActiveVisitors = () => ({ data: [] as any[], isLoading: false, error: null, refetch: async () => {} });
export const useVisitorStats = () => ({ data: { total: 0, authenticated: 0, anonymous: 0 }, isLoading: false });
export const useGeographicSummary = (_hours?: number) => ({ data: [] as any[], isLoading: false });
